<script setup lang="ts">
import type { Game } from '~/utils/games'

defineProps<{
  game: Game
}>()

const { t } = useI18n()
</script>

<template>
  <UPageCard
    :description="game.description"
    :icon="game.icon"
    :title="game.title"
    :to="game.route"
    :target="game.route ? '_blank' : undefined"
    :ui="{ root: 'flex flex-col', body: 'flex-1' }"
  >
    <template #footer>
      <div class="flex flex-wrap gap-1.5">
        <UBadge
          v-if="game.status === 'coming-soon'"
          :label="t('gameCard.comingSoon')"
          color="secondary"
          variant="subtle"
          size="sm"
        />
        <UBadge
          v-for="tag in game.tags"
          :key="tag"
          :label="tag"
          color="primary"
          variant="subtle"
          size="sm"
        />
      </div>
    </template>
  </UPageCard>
</template>
